import { WhatsappLogo } from "@phosphor-icons/react";
import { waLink } from "../../data/site";

export const FloatingWhatsApp = () => (
    <a
        href={waLink("Hai ASTANA KUCING'S, saya berminat dengan sangkar & catio kucing anda.")}
        target="_blank"
        rel="noreferrer"
        data-testid="floating-whatsapp"
        aria-label="WhatsApp ASTANA KUCING'S"
        className="pulse-ring fixed bottom-6 right-6 z-[120] flex h-14 w-14 items-center justify-center rounded-full bg-accent text-white shadow-lg hover:bg-accent-hover transition-colors duration-300"
    >
        <WhatsappLogo size={28} weight="fill" />
    </a>
);
